import React from 'react';
import { baseXUnit } from '../../styles/theme';
import RouteLink from '../navigation/RouteLink';
import { Paths } from '../../urls/Paths';
import Spacing from '../common/Spacing';
import IconText from '../common/IconText';
import HyperLink from '../elements/HyperLink';

interface HelpTopicLiftLinkProps {
  topicTitle: string;
  categorySlug: string;
}

const HelpTopicLiftLink: React.FunctionComponent<HelpTopicLiftLinkProps> = ({
  topicTitle,
  categorySlug
}) => {
  return (
    <Spacing bottom={1}>
      <RouteLink
        path={Paths.HelpCategory}
        params={{
          slug: categorySlug
        }}
      >
        <HyperLink>
          <div
            className="help-topic-lift-link"
            data-testid="help-topic-lift-link"
          >
            <IconText
              icon="nav-arrow-right"
              iconColor="purple-light"
              iconSize={4}
            >
              <strong>{topicTitle}</strong>
            </IconText>
          </div>
        </HyperLink>
      </RouteLink>
      {/*language=CSS*/}
      <style jsx>{`
        .help-topic-lift-link {
          margin-right: ${baseXUnit(1)};
        }
        strong {
          padding-top: ${baseXUnit(0.5)};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      `}</style>
    </Spacing>
  );
};

export default HelpTopicLiftLink;
